import { jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { ThemeProvider, Box } from "@mui/system";
import { createTheme } from "../../../constants/create-theme/create-theme.js";
import { CalendarEventIcon } from "../CalendarEventIcon/CalendarEventIcon.js";
import { CalendarIcon } from "../CalendarIcon/CalendarIcon.js";
import { CardIcon } from "../CardIcon/CardIcon.js";
import { ChecklistIcon } from "../ChecklistIcon/ChecklistIcon.js";
import { ClockIcon } from "../ClockIcon/ClockIcon.js";
import { CloseIcon } from "../CloseIcon/CloseIcon.js";
import { EditIcon } from "../EditIcon/EditIcon.js";
import { EmptyCalendarIcon } from "../EmptyCalendar/EmptyCalendar.js";
import { EventNoteIcon } from "../EventNote/EventNote.js";
import { FilterIcon } from "../FilterIcon/FilterIcon.js";
import { ListIcon } from "../ListIcon/ListIcon.js";
import { MessageBubbleIcon } from "../MessageBubble/MessageBubble.js";
import { PhoneIcon } from "../PhoneIcon/PhoneIcon.js";
import { PinIcon } from "../PinIcon/PinIcon.js";
import { SearchIcon } from "../SearchIcon/SearchIcon.js";
import { TherapyNotesIcon } from "../TherapyNotesIcon/TherapyNotesIcon.js";
import { TimerIcon } from "../TimerIcon/TimerIcon.js";
import { TreatmentChairIcon } from "../TreatmentChairIcon/TreatmentIcon.js";
import { VisibilityOffIcon } from "../VisibilityOffIcon/VisibilityOffIcon.js";
import { WarningIcon } from "../WarningIcon/WarningIcon.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "@mui/material";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../MainIcon/MainIcon.js";
const sizes = ["xs", "sm", "md", "lg", "xl"];
const theme = createTheme();
const GroupedIcon = ({ Icon }) => /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(
  Box,
  {
    sx: {
      p: 2,
      display: "flex",
      gap: 2,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flex: 1,
      minWidth: "fit-content"
    },
    children: sizes.map((size) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Icon, { size }) }, size))
  }
) });
const CalendarEvent = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: CalendarEventIcon });
const Calendar = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: CalendarIcon });
const EmptyCalendar = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: EmptyCalendarIcon });
const Card = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: CardIcon });
const Checklist = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: ChecklistIcon });
const Clock = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: ClockIcon });
const Close = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: CloseIcon });
const Edit = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: EditIcon });
const EventNote = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: EventNoteIcon });
const Filter = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: FilterIcon });
const List = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: ListIcon });
const MessageBubble = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: MessageBubbleIcon });
const Phone = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: PhoneIcon });
const Pin = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: PinIcon });
const Search = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: SearchIcon });
const TherapyNotes = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: TherapyNotesIcon });
const Timer = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: TimerIcon });
const TreatmentChair = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: TreatmentChairIcon });
const VisibilityOff = () => /* @__PURE__ */ jsx(GroupedIcon, { Icon: VisibilityOffIcon });
const all = {
  CalendarEventIcon,
  CalendarIcon,
  CardIcon,
  ChecklistIcon,
  ClockIcon,
  CloseIcon,
  EditIcon,
  EventNoteIcon,
  FilterIcon,
  ListIcon,
  MessageBubbleIcon,
  PhoneIcon,
  PinIcon,
  SearchIcon,
  TherapyNotesIcon,
  TimerIcon,
  TreatmentChairIcon,
  VisibilityOffIcon,
  WarningIcon,
  EmptyCalendarIcon
};
export {
  Calendar,
  CalendarEvent,
  Card,
  Checklist,
  Clock,
  Close,
  Edit,
  EmptyCalendar,
  EventNote,
  Filter,
  List,
  MessageBubble,
  Phone,
  Pin,
  Search,
  TherapyNotes,
  Timer,
  TreatmentChair,
  VisibilityOff,
  all as default
};
